<template>
  <div class="event-sort">
    <div class="container">
      <div class="icons-container" @click="toggleFilters()">

        <div :class="['icons', {selected: category==='party'}]">
          <div id="party-icon">
            <st-get-svg id="party-icon" rootFolder="project" platform="flag" class="filter-icon"/>
            <label for="">Party</label>
          </div>
        </div>
        <div :class="['icons', {selected: category==='candidate'}]">
          <div id="candidate-icon">
            <st-get-svg id="candidate-icon" rootFolder="project" platform="user" class="filter-icon"/>
            <label >Candidates</label>
          </div>
        </div>
        <div :class="['icons', {selected: category==='constituency'}]">
          <div id="district-icon">
            <st-get-svg id="district-icon" rootFolder="project" platform="pin" class="filter-icon pin-icon"/>
            <label for="">District</label>
          </div>
        </div>
      </div>
    </div>
    <v-select class="style-chooser" v-show="category" v-model="selectval" :options="options" :placeholder="placeholder"></v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import StGetSvg from '../../SvgFolder/StGetSvg.vue'
import {mapState} from 'vuex'

export default {
  props: ['attributes'],
  components: {
    vSelect, StGetSvg
  },
  computed: {
    ...mapState(['candidates', 'constituencies', 'parties'])
  },
  watch: {
    selectval: function (newVal) {
      this.$emit('option-selected', {category: this.category, categoryvalue: newVal})
    },
    category: function (newVal) {
      setTimeout(() => {
        this.$el.querySelector('.v-select').style.opacity = 1
      })
    }
  },
  data () {
    return {
      options: [],
      placeholder: 'Select a party, a candidates, or a district',
      category: '',
      selectval: ''
    }
  },
  methods: {
    toggleFilters () {
      const prevCategory = this.category
      if (event.target.closest('#party-icon')) {
        this.category = 'party'
        this.options = Object.keys(this.parties).map((key) => this.parties[key].name)
        this.placeholder = 'Select a party'
        document.getElementsByTagName('path')[5].outerHTML = '<path d="M0 2 L14 2 L7 9z"></path>'
      } else if (event.target.closest('#candidate-icon')) {
        this.category = 'candidate'
        this.options = Object.keys(this.candidates).map((key) => this.candidates[key].name)
        this.placeholder = 'Select a candidate'
        document.getElementsByTagName('path')[5].outerHTML = '<path d="M0 2 L14 2 L7 9z"></path>'
      } else if (event.target.closest('#district-icon')) {
        this.category = 'constituency'
        this.options = Object.keys(this.constituencies).map((key) => this.constituencies[key].name)
        this.placeholder = 'Select a district'
        document.getElementsByTagName('path')[5].outerHTML = '<path d="M0 2 L14 2 L7 9z"></path>'
      }
      this.selectval = prevCategory === this.category ? this.selectval : ''
    }
  },
  mounted () {
    this.$el.querySelector('.v-select').style.opacity = 0
  }
}
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
.event-sort {
  font-family: $font-CuratorRegular;
  font-size: 15px;
  margin-bottom: 30px;
  .container {
    width: 100%;
    .icons-container {
      display: flex;
      max-width: 300px;
      margin: 0 auto;
      .icons {
        text-align: center;
        margin: 2% auto 3%;
        :hover {
          cursor: pointer;
        }
        .filter-icon {
          width: 27px;
          height: 30px;

          svg * {
            fill: #C0CAC9;
          }
          &.pin-icon {
            width: 21px;
          }
        }

        img {
          min-width: 30px;
          max-width: 30px;
        }
        label {
          color: #C0CAC9;
          display: block;
          padding-top: 8px;
        }

        &.selected {
          svg * {
            fill: #333;
          }
          label {
            color: #333;
          }
        }
      }
    }
  }
  .v-select {
    max-width: 100%;
    width: 400px;
    margin: 0 auto;
    transition: opacity 1s ease-in-out;

    .vs__dropdown-toggle {
      background-color: #FFF;
    }
    input::placeholder {
      opacity: 0.3;
      font-family: $font-CuratorRegular;
    }
    ul.vs__dropdown-menu {
      .vs__dropdown-option--highlight {
        background: #5A9DDC;
      }
    }
    // .vs__open-indicator {
    //   background-image: url('../../../../assets/images/project/down-arrow.svg');
    // }
    .vs__open-indicator {
      fill: #333333;
    }
  }
}
</style>
